import { ExportVideoInfo, UpdateVideoInfo } from "../../models/video";
import VideoInfoEvents from "../events/VideoInfoEvents";

// 動画出力情報更新
export const UpdateVideo = (updateVideoInfo: UpdateVideoInfo) =>
    ({
        type: VideoInfoEvents.UpdateVideoInfoStarted,
        updateVideoInfo
    } as const);

export const UpdateVideoInfoComplete = (exportVideoInfo: ExportVideoInfo) =>
    ({
        type: VideoInfoEvents.UpdateVideoInfoComplete,
        exportVideoInfo
    } as const);

// 動画設定情報を変更
export const UpdateExportVideoInfo = (exportVideoInfo: ExportVideoInfo) =>
    ({
        type: VideoInfoEvents.UpdateExportVideoInfo,
        exportVideoInfo
    } as const);